import { actions } from "./action-list";

export function distanceReportFetched(value) {
  return {
    type: actions.FETCH_DISTANCE_REPORTS,
    value,
  };
}

export function mobileTicketFetched(value) {
  return {
    type: actions.FETCH_MOBILE_TICKETS_REPORTS,
    value,
  };
}

export function distanceReportDetailsFetched(value) {
  return {
    type: actions.FETCH_DISTANCE_REPORTS_DETAILS,
    value,
  };
}

export function mobileTicketsDetailsFetched(value) {
  return {
    type: actions.FETCH_MOBILE_TICKETS_DETAILS,
    value,
  };
}

export function mobileSettlementDetailsFetched(value) {
  return {
    type: actions.FETCH_MOBILE_SETTLEMENT_DETAILS,
    value,
  };
}

export function distanceReportDataSync(value) {
  return {
    type: actions.DISTANCE_REPORTS_DATA_SYNC,
    value,
  };
}

export function distanceUploadSheetFailure(value) {
  return {
    type: actions.DISTANCE_UPLOAD_FAILURE,
    value,
  };
}

export function passFetched(value) {
  return {
    type: actions.FETCH_PASS_REPORTS,
    value,
  };
}

export function passDetailsFetched(value) {
  return {
    type: actions.FETCH_PASS_DETAILS,
    value,
  };
}

export function passSettlementDetailsFetched(value) {
  return {
    type: actions.FETCH_PASS_SETTLEMENT_DETAILS,
    value,
  };
}

export function passRevenueDistributionFetched(value) {
  return {
    type: actions.FETCH_PASS_REVENUE_DISTRIBUTION,
    value,
  };
}

export function operatorWiseReportFetched(value) {
  return {
    type: actions.FETCH_OPERATOR_WISE_REPORT,
    value,
  };
}
